<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'partitions.projectionGraph.title.shortLabel' | translate}}
                <app-tooltip text="{{'partitions.projectionGraph.title.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="chart-container">
            <canvas id="canvas">{{ chart }}</canvas>
        </div>
    </mat-card-content>
</mat-card>
